<template>
  <button
    @click="toggleDark()"
    class="right-4 z-50 px-4 py-2 rounded bg-thenti-100 text-white dark:bg-thenti-900 shadow-lg"
  >
    {{ isDark ? '☀️ Light' : '🌙 Dark' }}
  </button>
</template>

<script setup>
import { useDark, useToggle } from '@vueuse/core'

const isDark = useDark({
  selector: 'html',
  attribute: 'class',
  valueDark: 'dark',
  valueLight: '',
})

const toggleDark = useToggle(isDark)
</script>
